import { call, put, select, takeLatest } from 'redux-saga/effects';
import { CREATE_FOLDER, DELETE_FILE, DELETE_FILES, DELETE_FOLDER, GET_FILE, GET_FOLDER, GET_ROOT, OPEN_FILE_PREVIEW_DRAWER, REFRESH_GED, UPDATE_FILE, UPDATE_FOLDER } from '../../constants';
import {
  closeFileModal,
  closeFolderModal,
  createFolderError,
  createFolderSuccess,
  deleteFileError,
  deleteFileSuccess,
  deleteFolderError,
  deleteFolderSuccess,
  getFile as getFileAction,
  getFileError,
  getFileSuccess,
  getFolder as getFolderAction,
  getFolderError,
  getFolderSuccess,
  getRoot as getRootAction,
  getRootError,
  getRootSuccess,
  refreshGed,
  sendEmailNotification,
  updateFileError,
  updateFileSuccess,
  updateFolderError,
  updateFolderSuccess
} from '../../redux/actions';
import { deleteFile, deleteFolder, getFile, getFolder, getPaths, getRoot, postDeleteFiles, postFolder, putFile, putFolder } from '../../services';

function* getRootAsync() {
  try {
    const { data } = yield call(getRoot);
    yield put(getRootSuccess(data));
  } catch {
    yield put(getRootError());
  } finally {
  }
}

function* getFolderAsync({ payload }) {
  try {
    const { data } = yield call(getFolder, payload);
    yield put(getFolderSuccess(data));
  } catch {
    yield put(getFolderError());
  } finally {
  }
}

function* getFileAsync({ payload }) {
  try {
    const { data } = yield call(getFile, payload);
    yield put(getFileSuccess(data));
  } catch {
    yield put(getFileError());
  } finally {
  }
}

function* createFolderAsync({ payload }) {
  try {
    yield call(postFolder, payload);
    yield put(createFolderSuccess());
    try {
      if (payload.parent) {
        const response = yield call(getPaths, payload.parent);
        const paths = response.data.data;
        const targetId = '60088d9920db335df1ebe386';
        const found = paths.some(path => path.includes(targetId));
        if (found) {
          yield call(sendEmailNotification, {
            email: 'credito@ruff.com.br, laercio@ruff.com.br',
            subject: 'Nova Pasta Criada',
            message: `Uma nova pasta chamada "${payload.title}" foi criada no sistema.`,
          });
        }
      }

    } catch (e) {
      // Loga o erro, mas não trava o fluxo
      console.error('Erro ao enviar e-mail:', e);
    }
    yield put(refreshGed());

    yield put(closeFolderModal());
    yield put(refreshGed());
  } catch {
    yield put(createFolderError());
  } finally {
  }
}

function* updateFolderAsync({ payload }) {
  try {
    const { id, params } = payload;
    yield call(putFolder, id, params);
    yield put(updateFolderSuccess());
    yield put(closeFolderModal());
    yield put(refreshGed());
  } catch {
    yield put(updateFolderError());
  } finally {
  }
}

function* refreshGedAsync() {
  const getFolderIdOpened = (state) => {
    return state.ged.folderOpened?._id;
  };
  const getFileIdOpened = (state) => {
    return state.ged.fileOpened?._id;
  };

  const folderIdOpened = yield select(getFolderIdOpened);
  const fileIdOpened = yield select(getFileIdOpened);

  if (!!folderIdOpened) {
    yield put(getFolderAction(folderIdOpened));
  } else {
    yield put(getRootAction());
  }
  if (!!fileIdOpened) {
    yield put(getFileAction(fileIdOpened));
  }
}

function* updateFileAsync({ payload }) {
  try {
    const { id, params } = payload;
    yield call(putFile, id, params);
    yield put(updateFileSuccess());
    yield put(closeFileModal());
    yield put(refreshGed());
  } catch {
    yield put(updateFileError());
  } finally {
  }
}

function* deleteFolderAsync({ payload }) {
  try {
    yield call(deleteFolder, payload);
    yield put(deleteFolderSuccess());
    yield put(refreshGed());
  } catch {
    yield put(deleteFolderError());
  } finally {
  }
}

function* deleteFileAsync({ payload }) {
  try {
    yield call(deleteFile, payload);
    yield put(deleteFileSuccess());
    yield put(refreshGed());
  } catch {
    yield put(deleteFileError());
  } finally {
  }
}

function* deleteFilesAsync({ payload }) {
  try {
    yield call(postDeleteFiles, payload);
    yield put(deleteFileSuccess());
    yield put(refreshGed());
  } catch {
    yield put(deleteFileError());
  } finally {
  }
}

export default function* rootSaga() {
  yield takeLatest([GET_FILE, OPEN_FILE_PREVIEW_DRAWER], getFileAsync);
  yield takeLatest(GET_ROOT, getRootAsync);
  yield takeLatest(GET_FOLDER, getFolderAsync);
  yield takeLatest(REFRESH_GED, refreshGedAsync);
  yield takeLatest(CREATE_FOLDER, createFolderAsync);
  yield takeLatest(UPDATE_FOLDER, updateFolderAsync);
  yield takeLatest(UPDATE_FILE, updateFileAsync);
  yield takeLatest(DELETE_FOLDER, deleteFolderAsync);
  yield takeLatest(DELETE_FILE, deleteFileAsync);
  yield takeLatest(DELETE_FILES, deleteFilesAsync);
}
